{
  "ReportingMenu_FirstClosePopup": "To reopen the menu, click the 'Reporting' button in the sidebar whilst on the Reporting page.",
  "NAME": "ReportingMenuLanguage"
}